import { useContext } from 'react';
import { AdminCadUsersContext } from '../shared/admin-caduser-provider';

export const useAdminCadUsers = () => {
	const context = useContext(AdminCadUsersContext);
	return {
		...context,
	};
};
